import React, { memo } from 'react';

function BrandRadarError() {
  return (
    <div className="BrandRadar-error">
      <span>Failed to load brand data</span>
      <button onClick={() => window.location.reload()}>Retry</button>
    </div>
  );
}

export default memo(BrandRadarError);
